module.exports = __webpack_public_path__ + "img/Full_logo.98aeb755.svg";